import { render, staticRenderFns } from "./SelectPayroll.vue?vue&type=template&id=c134ab12"
import script from "./SelectPayroll.vue?vue&type=script&lang=js"
export * from "./SelectPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports